const isValidDomain = require('is-valid-domain')
const urlParser = require ('js-video-url-parser')

export default class ValidaURL {

    static valida(rotulo,link) {
        const url = validaHttp(rotulo,link)
        validaDominio(rotulo,url)
        if (!eVideo(url)) {
            validaTipoArquivo(rotulo,url)
        }
    }
}

const validaHttp = (rotulo,_url) => {

    if (!_url) {
        throw obterMsgErro(rotulo)
    }

    const url = _url.trim()
    if (!url.includes('http://') && !url.includes('https://')) {
        throw obterMsgErro(rotulo)
    }

    return url
}

const obterMsgErro = rotulo => {
    return ({ status:400, tipo:'problema', texto:`URL contida em '${rotulo}' não é válida!` })
}

const validaDominio = (rotulo,url) => {

    const partes = url.split('/')
    if (partes.length < 3) {
        throw obterMsgErro(rotulo)
    }

    const dominio = partes[2]
    if (!isValidDomain(dominio)) {
        throw obterMsgErro(rotulo)
    }
}

const eVideo = url => {
    const resposta = urlParser.parse(url)
    if (resposta) {
        return true
    }

    const outrosServidoresDeVideo = [
        "facebook.com",
        "instagram.com",
        "twitter.com",
    ]
    let servidor = null
    for (let i=0; i<outrosServidoresDeVideo.length; i++) {
        servidor = outrosServidoresDeVideo[i]
        if (url.includes(servidor)) {
            return true
        }
    }

    return false
}

const validaTipoArquivo = (rotulo,url) => {
    const partes = url.split('.')
    if (partes.length === 0) {
        throw obterMsgErro(rotulo)
    }
    const sufixoUrl = "." + partes[partes.length - 1]

    const lista = listaTiposArquivos()
    let sufixoLista = null
    for (let i=0; i<lista.length; i++) {
        sufixoLista = lista[i]
        if (sufixoLista === sufixoUrl) {
            return true
        }
    }
    
    throw obterMsgErro(rotulo)
}

const listaTiposArquivos = () => {
    return [
        ".aif",
        ".cda",
        ".mid",
        ".midi",
        ".mp3",
        ".mpa",
        ".ogg",
        ".wav",
        ".wma",
        ".wpl",
        ".7z",
        ".arj",
        ".deb",
        ".pkg",
        ".rar",
        ".rpm",
        ".tar",
        ".gz",
        ".z",
        ".zip",
        ".bin",
        ".dmg",
        ".iso",
        ".toast",
        ".vcd",
        ".csv",
        ".dat",
        ".db",
        ".dbf",
        ".log",
        ".mdb",
        ".sav",
        ".sql",
        ".tar",
        ".xml",
        ".email",
        ".eml",
        ".emlx",
        ".msg",
        ".oft",
        ".ost",
        ".pst",
        ".vcf",
        ".fnt",
        ".fon",
        ".otf",
        ".ttf",
        ".ai",
        ".bmp",
        ".gif",
        ".ico",
        ".jpeg",
        ".jpg",
        ".png",
        ".ps",
        ".psd",
        ".svg",
        ".tif",
        ".tiff",
        ".cer",
        ".css",
        ".htm",
        ".html",
        ".part",
        ".xhtml",
        ".key",
        ".odp",
        ".pps",
        ".ppt",
        ".pptx",
        ".ods",
        ".xls",
        ".xlsm",
        ".xlsx",
        ".bak",
        ".cfg",
        ".icns",
        ".ico",
        ".sys",
        ".tmp",
        ".3g2",
        ".3gp",
        ".avi",
        ".h264",
        ".m4v",
        ".mkv",
        ".mov",
        ".mp4",
        ".mpg",
        ".mpeg",
        ".rm",
        ".swf",
        ".vob",
        ".wmv",
        ".doc",
        ".docx",
        ".odt",
        ".pdf",
        ".rtf",
        ".tex",
        ".txt",
        ".wpd",
        ".pgm"        
    ]
}